import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";

/**
 * Created by jonas on 2021-06-08.
 */

export class FreespinReTriggerPresentation implements SimplePresentation {

    constructor() {

    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline({onComplete:() => controller.finish()});
        tl.add(DasUBoot.winView.getFreespinReTriggerAnimation(DasUBoot.model.gameData.addedNumberOfFreespinsThisSpin, DasUBoot.model.gameData.freespinsLeft));
    }

    shouldRun():boolean {
        return DasUBoot.model.gameData.addedNumberOfFreespinsThisSpin > 0;
    }
}